<template>
  <div class="flex items-center h-full">
    <span
      v-if="params.value"
      class="px-2 py-1 rounded-full text-xs font-medium"
      :class="config.class"
    >
      {{ config.label }}
    </span>
  </div>
</template>

<script>
const TYPE_CONFIG = {
  'chart_review': { label: 'Chart Review', class: 'bg-blue-100 text-blue-700' },
  'outreach': { label: 'Outreach', class: 'bg-green-100 text-green-700' },
  'practice_list': { label: 'Practice List', class: 'bg-purple-100 text-purple-700' }
};

export default {
  name: 'Quality_ActionTypeCell',
  props: ['params'],
  computed: {
    config() {
      const type = this.params.value;
      return TYPE_CONFIG[type] || { label: type, class: 'bg-gray-100 text-gray-700' };
    }
  }
};
</script>
